import { Injectable, Inject } from "@angular/core";
import { StorageService } from "../services/storage.service";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { MeService } from "../services/me.service";
import { MeModel } from "../models/me.model";

@Injectable()
export class MeResolver implements Resolve<MeModel> {

  constructor(private service: MeService) { }

  resolve(route: ActivatedRouteSnapshot) {

    let promise: Promise<MeModel> = new Promise<MeModel>((resolve, reject) => {

      this.service.get()
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          reject(error);
        });

    });

    return promise;
  }

}
